
import Vue from 'vue'
import './util/rem'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import md5 from 'js-md5';
import "lib-flexible"
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/css/public.css';





Vue.use(ElementUI);
Vue.config.productionTip = false
Vue.prototype.$axios= axios;
Vue.prototype.$md5 = md5;
//  Vue.prototype.apiUrl='http://10.0.1.183:3000'     //线下环境
// Vue.prototype.apiUrl='http://120.46.139.113:3000'   //测试环境
Vue.prototype.apiUrl='https://api.hanglitong.com'     //正式环境
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
